import React from "react";
import { HandshakeIcon, LampIcon, MapPinIcon, PenLineIcon } from "lucide-react";
import { container } from "../../utils/styles";
const usps = [{
  icon: MapPinIcon,
  title: "Gemaakt in Nederland",
  text: "Ontworpen en geproduceerd in eigen studio"
}, {
  icon: PenLineIcon,
  title: "Te personaliseren",
  text: "Met naam, tekst of je eigen foto"
}, {
  icon: LampIcon,
  title: "Premium onderdelen",
  text: "Italiaanse Creative-Cables voet en snoer"
}, {
  icon: HandshakeIcon,
  title: "Persoonlijk contact",
  text: "We denken graag met je mee"
}];
export function UspBar() {
  return <section aria-label="Waarom Koers Design" className="border-b border-line bg-paper" data-id="element-228" data-mp="2s47she2ozxa">
      <ul className={`${container} grid grid-cols-2 gap-x-6 gap-y-6 py-8 lg:grid-cols-4`} data-id="element-229" data-mp="7qxkw8pg6owx">
        {usps.map(({
        icon: Icon,
        title,
        text
      }) => <li key={title} className="flex items-start gap-3" data-id="element-230" data-mp="crbj6z18ykhr">
            <Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.6} data-id="element-231" data-mp="hov76qnqybmw" />
            <span data-id="element-232" data-mp="326lcl450138u">
              <span className="block text-sm font-medium text-ink" data-id="element-233" data-mp="3274kds0xqb95">{title}</span>
              <span className="mt-0.5 block text-sm text-muted" data-id="element-234" data-mp="2x7i7xksxkz1e">{text}</span>
            </span>
          </li>)}
      </ul>
    </section>;
}